import Vue from 'vue';
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

Swiper.use([Navigation]);

Vue.component('quote-slider', {
    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
        };
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
        this.swiperInit();
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        swiperInit() {
            this.slider = new Swiper(this.$refs.slider, {
                modules: [Navigation],
                loop: true,
                breakpoints: {
                    0: {
                        slidesPerView: 1,
                        slidesPerGroup: 1,
                        spaceBetween: 20,
                    },
                    1024: {
                        slidesPerView: 2,
                        slidesPerGroup: 2,
                        spaceBetween: 40,
                    },
                },
                navigation: {
                    nextEl: this.$refs.quoteSliderNext,
                    prevEl: this.$refs.quoteSliderPrev,
                },
            });
        },
    },
});
